import { defaultTheme } from "@amzn/storm-ui";

export const DEFAULT_TOUR_STYLES = {
    options: {
        primaryColor: defaultTheme.color.gray[1000],
        backgroundColor: defaultTheme.color.gray[0],
        textColor: defaultTheme.color.gray[800],
        overlayColor: "rgba(0, 0, 0, 0.4)",
        spotlightShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
        beaconSize: 36,
    },
};
